import { render } from "./WhoWeAreModal.vue?vue&type=template&id=e7918772&scoped=true"
import script from "./WhoWeAreModal.vue?vue&type=script&lang=js"
export * from "./WhoWeAreModal.vue?vue&type=script&lang=js"

import "./WhoWeAreModal.vue?vue&type=style&index=0&id=e7918772&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7918772"]])

export default __exports__